
<template >
  <d2-container>
    <div class="containerDiv">
      <div class="d2Title">采购申请单</div>

      <div class="elFormDiv">
        <el-form ref="infoForm" :model="discountApply" label-position="top">
          <el-form-item
            label="驳回原因"
            class="formItem"
            v-if="discountApply.rejectReason"
            prop="goodsDesc"
          >
            <el-input
              v-model="discountApply.rejectReason"
              autocomplete="off"
              readonly
              style="width: 88%"
            ></el-input>
          </el-form-item>
          <el-form-item label="采购物品" class="formItem" prop="goodsDesc">
            <el-input
              type="textarea"
              :rows="4"
              :readonly="isAapprovateStateWAIT"
              :autosize="{ minRows: 4, maxRows: 4 }"
              placeholder="请输入采购物品"
              v-model="discountApply.goodsDesc"
            >
            </el-input>
          </el-form-item>
          <div class="budgetAmount">
            <div>预算金额</div>
            <el-input
              v-model="discountApply.budgetMoney"
              type="number"
              :readonly="isAapprovateStateWAIT"
              maxlength="10"
              placeholder="请输入预算金额"
            >
              <div slot="prefix" class="elIcon">¥</div>
            </el-input>
          </div>
          <el-form-item label="上传附件" class="formItem">
            <div class="formItemImage">
              <div
                v-for="(item, index) in imageList"
                :key="index"
                class="Imageuploader"
              >
                <img :src="item" alt="" />
                <i
                  class="el-icon-circle-close elClose"
                  v-if="!isAapprovateStateWAIT"
                  @click.stop="onClickClose(index)"
                />
              </div>
              <el-upload
                v-if="!isAapprovateStateWAIT && imageList.length < 10"
                action="#"
                class="coverPic-uploader"
                list-type="picture-card"
                multiple
                :limit="limit"
                :show-file-list="false"
                :auto-upload="false"
                :on-change="beforeCoverPicUpload"
              >
                <i class="el-icon-plus coverPic-uploader-icon"></i>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="备注信息" class="formItem" prop="remark">
            <el-input
              type="textarea"
              :rows="4"
              :autosize="{ minRows: 4, maxRows: 4 }"
              placeholder="请输入备注信息"
              maxlength="200"
              :readonly="isAapprovateStateWAIT"
              v-model="discountApply.remark"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-form>
        <div
          style="text-align: center; padding-top: 2rem"
          v-if="
            discountApply.approvateState == 'AGREE' ||
            discountApply.approvateState == 'REJECT'
          "
        >
          <div>
            <i
              class="el-icon-success"
              style="font-size: 4em; color: #07c160"
              v-if="discountApply.approvateState == 'AGREE'"
            ></i>
            <i
              class="el-icon-error"
              style="font-size: 4em; color: #cc5656"
              v-if="discountApply.approvateState == 'REJECT'"
            ></i>
          </div>
          <el-button
            type="success"
            disabled
            style="
              width: 90%;
              height: 3rem;
              font-size: 1.5rem;
              margin-top: 1rem;
            "
            v-if="discountApply.approvateState == 'AGREE'"
            >{{
              discountApply ? discountApply.approvateUserName : ""
            }}
            已通过</el-button
          >
        </div>
        <div
          style="text-align: center; padding-top: 2rem"
          v-if="isAapprovateStateWAIT"
        >
          <el-button
            type="success"
            disabled
            style="
              width: 90%;
              height: 3rem;
              font-size: 1.5rem;
              margin-top: 1rem;
            "
          >
            待审核</el-button
          >
        </div>
        <div
          class="submitBox"
          v-if="
            discountApply.approvateState !== 'AGREE' && !isAapprovateStateWAIT
          "
        >
          <el-button
            class="submitApplication"
            :disabled="!isSave"
            :type="isSave ? 'success' : 'danger'"
            @click="submitApplication"
          >
            提交申请
          </el-button>
        </div>
      </div>
    </div>
  </d2-container>
</template>
<script>
import { mapActions } from "vuex";
// import util from "@/libs/util";
// import dateUtil from "@/utils/dateUtil";
export default {
  title: "采购申请-天堂墓园",
  data() {
    return {
      reverse: true,
      openId: this.$route.query.openid, //微信openid可以确定user
      id: null,
      userInfo: null,
      loading: null,
      limit: 10,
      isAapprovateStateWAIT: false,
      imageList: [],
      isSave: false,
      discountApply: {
        openid: this.$route.query.openid,
        userId: '',
        userName: '',
        goodsDesc: '',
        budgetMoney: '',
        remark: '',
        imgFile: ''
      }, //申请信息
      message: ""
    };
  },
  methods: {
    ...mapActions("d2admin/purchasing", [
      "getUser",
      "purchasingImage",
      "savePurchase",
      "updatePurchase",
      "getPurchaseRequisition"
    ]),
    onGetUser() {
      this.getUser({ openId: this.openId }).then((res) => {
        if (res.data.result == "1") {
          this.isSave = true
          this.userInfo = res.data.data.alias1
          this.discountApply.userId = this.userInfo.id
          this.discountApply.userName = this.userInfo.nickName
        } else {
          this.message = res.data.message
          this.$alert(res.data.message, '操作提示', {
            confirmButtonText: '确定'
          })
        }
      }).catch((err) => {

      });
    },
    beforeCoverPicUpload(file) {
      console.log(file)
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
        return isLt2M;
      }
      this.loading = this.$loading({
        fullscreen: true,
        text: '上传中',
        background: "rgba(0, 0, 0, 0.6)"
      })
      const rawFile = file.raw
      const formData = new FormData()
      formData.append('file', rawFile)
      let parm = {
        openId: this.openId,
        userId: this.discountApply.userId,
        file: formData,
        path: 'purchasingImage'
      }
      if (this.limit - this.imageList.length <= 0) {
        this.imageList = []
      }
      this.purchasingImage(parm).then((res) => {
        console.log(res)
        if (this.limit - this.imageList.length > 0) {
          this.imageList.push(res.data)
        }
        this.loading.close()
      }).catch(() => {
        this.loading.close()
      })
    },
    submitApplication() {
      if (!this.isSave) {
        this.$alert(this.message, '操作提示', {
          confirmButtonText: '确定'
        })
      }
      let parm = this.discountApply
      parm.imgFile = this.imageList.toString()
      if (this.id) {
        parm.id = this.id
        this.updatePurchase(parm).then((res) => {
          // this.discountApply = {
          //   id: this.id,
          //   openid: this.$route.query.openId,
          //   userId: '',
          //   userName: '',
          //   goodsDesc: '',
          //   budgetMoney: '',
          //   remark: '',
          //   imgFile: ''
          // }
          // this.$refs.infoForm.resetFields();
          if (res.data) {
            this.isAapprovateStateWAIT = true;
            this.$alert('重新申请成功', '操作提示', {
              confirmButtonText: '确定'
            })
          }
        })
      } else {
        this.savePurchase(parm).then((res) => {
          if (res.data) {
            this.discountApply = {
              openid: this.$route.query.openid,
              userId: '',
              userName: '',
              goodsDesc: '',
              budgetMoney: '',
              remark: '',
              imgFile: ''
            }
            this.imageList = []
            this.$refs.infoForm.resetFields();
            this.isAapprovateStateWAIT = true;
            this.$alert('申请成功', '操作提示', {
              confirmButtonText: '确定'
            })
          }
        })
      }

    },
    queryPurchaseRequisition() {
      let parm = {}
      if (this.$route.query.id) {
        parm.id = this.$route.query.id
      }
      this.getPurchaseRequisition(parm).then((res) => {
        if (res.data.result == "1") {
          this.discountApply = res.data.data.PurchaseRequisition
          this.discountApply.openid = this.$route.query.openid
          if (res.data.data.PurchaseRequisition.imgFile) {
            let imageList = this.discountApply.imgFile.split(",")
            if (imageList.length > 0 && imageList[0] != '') {
              this.imageList = imageList
            }
          }
        } else {
          this.$alert(res.data.message, '操作提示', {
            confirmButtonText: '确定'
          })
        }
      })
    },
    onClickClose(idex) {
      this.imageList.splice(idex, 1)
    }
  },
  mounted() {
    this.onGetUser()
    if (this.$route.query.id && this.$route.query.id != 'null' && this.$route.query.id != '') {
      this.id = this.$route.query.id
      this.queryPurchaseRequisition()
    }
  },
};
</script>
<style lang="scss">
.el-message-box {
  width: 80%;
}
img {
  width: 100%;
  height: 100%;
}
.containerDiv {
  display: flex;
  flex-direction: column;
  width: 100%;
  // height: 100%;
  overflow: hidden;
}
.d2Title {
  width: 100%;
  margin-top: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  color: #3d3d3d;
}
.elFormDiv {
  padding: 0px 40px;
  flex: 1;
  overflow: hidden;
  overflow-y: auto;
}
.budgetAmount {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #555555;
  .el-input {
    width: 150px;
  }
  .el-input__inner {
    border-top: 0px;
    border-left: 0px;
    border-right: 0px;
    border-radius: 0px;
  }
  .el-input__prefix {
    display: flex;
    align-items: center;
  }
  .elIcon {
    font-size: 16px;
    color: #ff7676;
    display: flex;
    align-items: center;
  }
}
.submitBox {
  margin-top: 64px;
  margin-bottom: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.submitApplication {
  width: 235px;
  height: 40px;
  border-radius: 4px;
  background: #67c23a;
  font-size: 16px;
  letter-spacing: 0px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.formItemImage {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.Imageuploader {
  width: 142px;
  height: 142px;
  margin-bottom: 10px;
  position: relative;
}
.elClose {
  position: absolute;
  top: 6px;
  right: 8px;
  font-size: 20px;
  color: red;
}
</style>